export enum UnitsSymbolEnum {
    "%"="%",
    "€"="€"
}

export enum UnitsStringToSymbolEnum {
    percentage = UnitsSymbolEnum["%"],
    amount = UnitsSymbolEnum["€"]
}